import { useState } from "react";
import {
  TubyImg,
  NearbyImg,
  CoffeetalkdashImg,
  AldahranImg,
  AldahranProfileImg,
  LaqtaSiteLoaderImg,
  MarsImg,
  AjadImg,
  LaqtaAllInOneImg,
  NetflixClone,
} from "../../images";
import { Plus } from "../../Components/Icons";
import * as G from "./stylegallery";

const portfolio = [
  {
    id: 1,
    img: TubyImg,
    filter: ["all", "react-typeScript"],
    title: "Tuby",
    subtitle:
      "A platform for watching videos without ads ( Get data from RapidAPIs )",
    link: "https://github.com/devmaheremad/tuby",
  },
  {
    id: 2,
    img: NearbyImg,
    filter: ["all", "react-typeScript"],
    title: "Nearby",
    subtitle:
      "A platform to find the best restaurants | hotels | and attractions",
    link: "https://github.com/devmaheremad/nearby",
  },
  {
    id: 3,
    img: NetflixClone,
    filter: ["all", "react-typeScript"],
    title: "Netflix Clone",
    subtitle:
      "A platform to find the best restaurants | hotels | and attractions",
    link: "https://github.com/devmaheremad/netflix-react-ts-2023",
  },
  {
    id: 4,
    img: AjadImg,
    filter: ["all", "bootstrap"],
    title: "AJAD Landing page",
    subtitle:
      "An Emirati Total Facility Management established in 2002 based in UAE ",
    link: "https://devmaheremad.github.io/ajad",
  },
  {
    id: 5,
    img: AldahranImg,
    filter: ["all", "bootstrap"],
    title: "Dahran Schools",
    subtitle: "A dashboard to handle all current features within a mobile app",
    link: "https://devmaheremad.github.io/aldahran",
  },
  {
    id: 6,
    img: LaqtaAllInOneImg,
    filter: ["all", "bootstrap"],
    title: "Laqta Coming Soon",
    subtitle: "Coming soon brand-new page for our vendor Laqta",
    link: "https://devmaheremad.github.io/laqtaAllInOne",
  },
  {
    id: 7,
    img: LaqtaSiteLoaderImg,
    filter: ["all", "bootstrap"],
    title: "Laqtah",
    subtitle:
      "A company that specializes high-quality photography, motion graphics, app development ",
    link: "https://devmaheremad.github.io/laqtasiteloader",
  },
  {
    id: 8,
    img: MarsImg,
    filter: ["all", "bootstrap"],
    title: "Mars Site",
    subtitle: "A creative site for Mars company",
    link: "https://devmaheremad.github.io/Mars-master",
  },
  {
    id: 9,
    img: AldahranProfileImg,
    filter: ["all", "dashboard"],
    title: "Dahran Schools DashBoard",
    link: "https://devmaheremad.github.io/aldahran/profile",
  },
  {
    id: 10,
    img: CoffeetalkdashImg,
    filter: ["all", "dashboard"],
    title: "Coffee Talk",
    subtitle: "A dashboard to handle all current features within a mobile app",
    link: "https://devmaheremad.github.io/coffeetalkdash/home",
  },
];

export default function Gallery() {
  const [active, setActive] = useState("all");

  return (
    <G.Content>
      <G.Nav>
        <G.NavItem
          onClick={() => setActive("all")}
          className={`${active === "all" ? "active" : null}`}
        >
          All
        </G.NavItem>
        <G.NavItem
          onClick={() => setActive("react-typeScript")}
          className={`${active === "react-typeScript" ? "active" : null}`}
        >
          React + TypeScript
        </G.NavItem>
        <G.NavItem
          onClick={() => setActive("dashboard")}
          className={`${active === "dashboard" ? "active" : null}`}
        >
          Dashboard-Bootstrap
        </G.NavItem>
        <G.NavItem
          onClick={() => setActive("bootstrap")}
          className={`${active === "bootstrap" ? "active" : null}`}
        >
          Webeite-Bootstrap
        </G.NavItem>
      </G.Nav>
      <G.Picture>
        {portfolio.map((item) => (
          <G.DivImg
            className={
              item.filter.includes(active) ? "animationIn" : "animationOut"
            }
            key={item.id}
          >
            <G.Image src={item.img} alt={item.img} />
            <G.Overlay>
              <h3 className="project-title">{item.title}</h3>
              <h6 className="project-subtitle">{item.subtitle}</h6>
              <a href={item.link}>
                <Plus className="plus" />
              </a>
            </G.Overlay>
          </G.DivImg>
        ))}
      </G.Picture>
    </G.Content>
  );
}
